// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"197":"0768fd7961d52b4e","427":"3e207a57652a3bcd","820":"0768fd7961d52b4e","888":"8b2a2cdb5f41fe0c"}[chunkId] + ".css";
};